<template>
  <div>
    <el-menu style="position: fixed;left: 0;width: 200px;height:100%;top: 0;padding-top: 20px;text-align: left;"
      :default-active="activeName" class="el-menu-vertical-demo" @select="handleSelect" background-color="#FFFFFF"
      :text-color="defaultColor" :active-text-color="activeColor">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location" :style="{'color':iconColor('1')}"></i>
          <span class="menu-text">地点库</span>
        </template>
        <el-menu-item index="1-1">
          <template slot="title" class="menu-text">地图模式</template>
        </el-menu-item>
        <el-menu-item index="1-2">
          <template slot="title" class="menu-text">列表模式</template>
        </el-menu-item>
      </el-submenu>
      <el-menu-item index="2">
        <i class="el-icon-user-solid" :style="{'color':iconColor('2')}"></i>
        <span slot="title" class="menu-text">团队管理</span>
      </el-menu-item>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-s-promotion" :style="{'color':iconColor('3')}"></i>
          <span class="menu-text">路线管理</span>
        </template>
        <el-menu-item index="3-1">
          <template slot="title" class="menu-text">路线列表</template>
        </el-menu-item>
        <el-menu-item index="3-2">
          <template slot="title" class="menu-text">路线规划</template>
        </el-menu-item>
        <el-menu-item index="3-3">
          <template slot="title" class="menu-text">多车路线排单规划</template>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-s-shop" :style="{'color':iconColor('4')}"></i>
          <span class="menu-text">会员中心</span>
        </template>
        <el-menu-item index="4-1">
          <template slot="title" class="menu-text">会员购买</template>
        </el-menu-item>
        <el-menu-item index="4-2">
          <template slot="title" class="menu-text">会员升级</template>
        </el-menu-item>
      </el-submenu>
      <!--      <el-menu-item index="5">-->
      <!--        <i class="el-icon-s-comment"></i>-->
      <!--        <span slot="title">联系客服</span>-->
      <!--      </el-menu-item>-->
      <el-menu-item index="6">
        <i class="el-icon-question" :style="{'color':iconColor('6')}"></i>
        <span slot="title" class="menu-text">使用教程</span>
      </el-menu-item>
    </el-menu>
    <div class="team-details">
      <div style="display: flex;flex-direction: column;margin-left: 10px;">
        <span style="font-size: 16px;font-weight: 500;">{{ team.name }}(V{{ team.vip_type }})</span>
        <span style="font-size: 12px;padding-top: 4px;color: #666666">{{ team.vip_expiration_time }}</span>
      </div>
      <i style="font-size: 24px;font-weight: bold;margin-right: 10px;" class="el-icon-switch-button" @click="logout"></i>
    </div>
    <Common :commentFormState="commentFormState" :memberUpgradeState="memberUpgradeState" :options="options"></Common>
  </div>
</template>

<script>
import store from 'store'
import Common from '@/components/Common.vue'
import { GetUpgradeableLevel } from '../api/member.js'
import { GetTeamDetails } from '../api/team.js'

export default {
  name: 'Menu',
  components: { Common },
  data() {
    return {
      team: {},
      dialogTableVisible: false,
      commentFormState: false,
      memberUpgradeState: false,
      activeColor:'#2979ff',
      defaultColor:'#333333',
      options: []
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    }
  },
  mounted() {
    this.team = store.get('team')
    this.getTeamDetails()
  },
  methods: {
    iconColor(name){
      if(this.activeName == name ) {
        return this.activeColor
      }
      return this.defaultColor
    },
    logout() {
      store.remove('team')
      store.remove('token')
      this.$router.push({ name: 'login' })
    },
    getTeamDetails() {
      GetTeamDetails().then(res => {
        if (res.code === 200) {
          this.team = res.data.info
        }
      })
    },
    handleSelect(e) {
      switch (e) {
        case '1-1':
          this.$router.push({ name: 'index' })
          break
        case '1-2':
          this.$router.push({ name: 'place' })
          break
        case '2':
          this.$router.push({ name: 'personnel' })
          break
        case '3-1':
          this.$router.push({ name: 'route-list' })
          break
        case '3-2':
          this.$router.push({ name: 'plan' })
          break
        case '3-3':
          this.$router.push({ name: 'multi-vehicle-plan' })
          break
        case '4-1':
          window.open('/#/member')
          break
        case '4-2':
          this.getVipType()
          break
        case '5':
          break
        case '6':
          window.open('https://www.yuque.com/yancheng-udx5g/iwf8ox/qh5u97')
          break
      }
    },
    getVipType() {
      var that = this
      GetUpgradeableLevel().then(res => {
        if (res.code === 200) {
          that.options = res.data
          that.memberUpgradeState = true
        } else {
          that.$notify({
            title: '错误',
            type: 'error',
            message: res.message,
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.menu-text {
  font-size: 14px;
  font-weight: 400;
}
.team-details {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #EEEEEE;
  height: 80px;
  width: 200px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  flex-direction: row;
  color: #333333;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue